import { DefaultHandlerType } from "../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/models/enums";

export interface IUnitDefaultHandlersNodeUser {
    code: string;
    type: DefaultHandlerType;
    name: string;
    picture: string;
}

export class UnitDefaultHandlersNodeUser implements IUnitDefaultHandlersNodeUser {
    code: string;
    type: DefaultHandlerType;
    name: string;
    picture: string;

    constructor();
    constructor(obj: IUnitDefaultHandlersNodeUser);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.type = obj && obj.type || DefaultHandlerType.Handler;
        this.name = obj && obj.name || "";
        this.picture = obj && obj.picture || "";
    }

    static sortUnitDefaultHandlersNodeUsers(src: UnitDefaultHandlersNodeUser[], asc: boolean): UnitDefaultHandlersNodeUser[] {
        const result = src.slice(0);
        result.sort((a: UnitDefaultHandlersNodeUser, b: UnitDefaultHandlersNodeUser) => {
            if ((a === null || a === undefined) && (b === null || b === undefined)) return 0;
            if (a === null || a === undefined) return 1;
            if (b === null || b === undefined) return -1;
            if ((a.name === null || a.name === undefined) && (b.name === null || b.name === undefined)) return 0;
            if (a.name < b.name) return (asc ? 1 : -1) * -1;
            if (a.name > b.name) return (asc ? 1 : -1) * 1;
            return 0;
        });
        return result;
    }
}